import IFinancialModel from '../IFinancialModel'
import { API } from 'aws-amplify'

export class FinancialModelDataStoreAWS extends IFinancialModel {

  // Assuming AXIOS is being used by Amplify library
  handleError(err, functionName) {
    if (err.response) {
      let text = `${err.message} ${JSON.stringify(err.response.data)}`
      console.log(`ERROR ${functionName} status: ${err.response.status}`)
      console.log(`ERROR ${functionName} data: ${JSON.stringify(err.response.data)}`)
      console.log(`ERROR ${functionName} headers: ${JSON.stringify(err.response.headers, null, 2)}`)
      let error = new Error(text)
      error.status = err.response.status
      error.statusText = err.response.statusText
      return error
    }
    console.log(`ERROR ${functionName} request: ${err.message}`)
    return err
  }

  postForecast = async (forecast) => {
    try {
      const res = await API.post('companies', '/companies/financial-model/forecast', {
        body: {
          "forecast": {...forecast}
        },
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data['forecast']) {
        return res.data['forecast']
      } else {
        console.error(`FinancialModel postForecast data missing: ${JSON.stringify(res.data, null, 2)}`)
        throw new Error('FinancialModel postForecast data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'FinancialModel postForecast')
    }
  }
  
  // Returns a promise
  createForecast(forecast) {
    return this.postForecast(forecast)
  }

  putForecast = async (forecastId, forecast) => {
    try {
      await API.put('companies', `/companies/financial-model/forecast/object/${forecastId}`, {
        body: {
          "forecast": {...forecast}
        },
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'FinancialModel putForecast')
    }
  }
  
  // Returns a promise
  storeForecast(forecastId, forecast) {
    return this.putForecast(forecastId, forecast)
  }

  getForecast = async () => {
    try {
      const res = await API.get('companies', '/companies/financial-model/forecast/object', {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data['forecast']) {
        return res.data['forecast']
      } else {
        console.error(`FinancialModel getForecast data missing: ${JSON.stringify(res.data, null, 2)}`)
        throw new Error('FinancialModel getForecast data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'FinancialModel getForecast')
    }
  }
  
  // Returns a promise
  retrieveForecast() {
    return this.getForecast()
  }

  delForecast = async (forecastId) => {
    try {
      await API.del('companies', `/companies/financial-model/forecast/object/${forecastId}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'FinancialModel delForecast')
    }
  }
  
  // Returns a promise
  removeForecast(forecastId) {
    return this.delForecast(forecastId)
  }

}

export default FinancialModelDataStoreAWS
